import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@components/ui/Tooltip';
import {
  DECISION_PENDING,
  STATUS_LABELS,
} from '@operations/domain/operation/detail';
import { cn } from '@utils/cn';
import { useState } from 'react';

import { BADGE_BASE_CLASS, STATUS_CLASSES } from '../constants';
import type { DecisionBadgeProps } from '../types';
import { getDecisionLabel } from './getDecisionLabel';

const DecisionBadge = ({
  areaName,
  status,
  userName,
  decidedAt,
  isClosedOperation,
}: DecisionBadgeProps) => {
  const [open, setOpen] = useState(false);
  const colorClass = STATUS_CLASSES[status];
  const initial = areaName.trim().charAt(0).toUpperCase();
  const isPending = status === DECISION_PENDING;

  const decisionLabel = getDecisionLabel({
    userName,
    decidedAt,
    isClosedOperation,
    isPending,
  });

  return (
    <TooltipProvider>
      <Tooltip delayDuration={100} open={open} onOpenChange={setOpen}>
        <TooltipTrigger
          type="button"
          aria-label={
            isPending
              ? `${areaName}: ${decisionLabel}`
              : `${areaName}: ${STATUS_LABELS[status]}`
          }
          onClick={() => setOpen(true)}
          className={cn('cursor-default', BADGE_BASE_CLASS, colorClass)}
        >
          <span aria-hidden="true">{initial}</span>
        </TooltipTrigger>
        <TooltipContent>
          {isPending ? (
            <div className="space-y-0.5 text-xs">
              <p className="font-bold">{areaName}</p>
              <p>{decisionLabel}</p>
            </div>
          ) : (
            <div className="space-y-0.5 text-xs">
              <p className="font-bold">{areaName}</p>
              <p>{STATUS_LABELS[status]}</p>
              {decisionLabel && <p>{decisionLabel}</p>}
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { DecisionBadge };
